// import React, { useEffect, useState } from 'react';
// import { BarChart3, Users, MessageCircle, TrendingUp, Settings, Menu, X, Facebook, Instagram, Phone, Calendar, MapPin, User, Bell, Search, Link, Cookie } from 'lucide-react';
// import ChartComponent from '../../../components/PlatformWiseChart';
// import PieChartComponent from '../../../components/PieChartComponent';
// import { userProfile } from '../../../store/user/userThunk';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import ConversationAnalytics from '../../../components/ConversationAnalytics';
// import Cookies from "js-cookie";
// const Dashboard = () => {
//   const { profile } = useSelector((state) => state.userservice);

//   const navigate = useNavigate()
//   const location = useLocation();
//   const [showQRModal, setShowQRModal] = useState(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const urlParams = new URLSearchParams(location.search);
//     const loginStatus = urlParams.get('login');
//     const provider = urlParams.get('provider');
//     const token = urlParams.get('token');
//     if (provider === 'google' && token) {
//       Cookies.set('token', token, { expires: 45, secure: true, sameSite: 'Strict' });
//     }

//     if (loginStatus === 'success' && provider) {
//       toast.success(`${provider.charAt(0).toUpperCase() + provider.slice(1)} account connected successfully!`);
//       navigate(location.pathname, { replace: true });
//     }
//   }, [location, navigate]);
//   const QRCodeComponent = ({ value, size = 200 }) => (
//     <div className="flex items-center justify-center p-4">
//       <div className="w-48 h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
//         <span className="text-gray-500 text-sm">QR Code: {value}</span>
//       </div>
//     </div>
//   );
//   return (
//     <div className="flex  bg-gray-50">
//       {/* <Sidebar /> */}
//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Main Content Area */}
//         <main className="flex-1 overflow-x-hidden  bg-gray-50">
//           <div className="container mx-auto px-6 py-8">
//             {/* Stats Cards */}
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm font-medium text-gray-600">Total Connectd Platform </p>
//                     <p className="text-3xl font-bold text-gray-900">
//                       {+profile?.iglogin + +profile?.Fblogin + +profile?.wpLogin}
//                     </p>

//                   </div>
//                   <div className="p-3 bg-blue-50 rounded-lg">
//                     <Link className="text-[#50B5FF]" size={24} />
//                   </div>
//                 </div>
//               </div>

//               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm font-medium text-gray-600">Instagram Connected</p>
//                     <p className="text-3xl font-bold text-gray-900">{profile?.iglogin ? 'Online' : 'Offline'}</p>
//                     <p className="text-sm text-blue-600">Status: {profile?.iglogin ? "Active" : 'Deactive'}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded-lg">
//                     <Instagram className="text-pink-600" size={24} />
//                   </div>
//                 </div>
//               </div>

//               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm font-medium text-gray-600">Facebook Connected</p>
//                     <p className="text-3xl font-bold text-gray-900">{profile?.Fblogin ? 'Online' : 'Offline'}</p>
//                     <p className="text-sm text-blue-600">Status: {profile?.Fblogin ? "Active" : 'Deactive'}</p>
//                   </div>
//                   <div className="p-3 bg-blue-50 rounded-lg">
//                     <Facebook className="text-blue-600" size={24} />
//                   </div>
//                 </div>
//               </div>

//               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm font-medium text-gray-600">WhatsApp</p>
//                     <p className="text-3xl font-bold text-gray-900">{profile?.wpLogin ? 'Connected' : 'Offline'}</p>
//                     <p className="text-sm text-blue-600">Status: {profile?.wpLogin ? "Active" : 'Deactive'}</p>

//                     {/* <button
//                       onClick={() => setShowQRModal(true)}
//                       className="text-sm text-[#50B5FF] hover:underline mt-1"
//                     >
//                       Scan QR Code
//                     </button> */}
//                   </div>
//                   <div className="p-3 bg-green-50 rounded-lg">
//                     <Phone className="text-green-500" size={24} />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <ConversationAnalytics />

//             {/* Profile Section */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//               {/* Profile Info */}
//               <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//                 <h3 className="text-lg font-semibold text-gray-800 mb-6">Profile Information</h3>
//                 <div className="space-y-4">
//                   <div className="flex items-center space-x-3">
//                     <img
//                       src={profile?.image}
//                       alt="Profile"
//                       className="w-16 h-16 rounded-full object-cover"
//                     />
//                     <div>
//                       <h4 className="font-medium text-gray-900">{profile?.fullName}</h4>
//                       <p className="text-sm text-gray-500">@{profile?.userName}</p>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-1 gap-3">
//                     <div className="flex items-center text-sm">
//                       <User size={16} className="mr-2 text-gray-400" />
//                       <span className="text-gray-600">Gender:</span>
//                       <span className="ml-auto font-medium">{profile?.gender}</span>
//                     </div>
//                     <div className="flex items-center text-sm">
//                       <Calendar size={16} className="mr-2 text-gray-400" />
//                       <span className="text-gray-600">Birth Date:</span>
//                       <span className="ml-auto font-medium">{profile?.dob}</span>
//                     </div>
//                     <div className="flex items-center text-sm">
//                       <MapPin size={16} className="mr-2 text-gray-400" />
//                       <span className="text-gray-600">Location:</span>
//                       <span className="ml-auto font-medium">{profile?.city}, {profile?.state}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>

//       {/* QR Code Modal */}
//       {showQRModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl max-w-md w-full">
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-4">
//                 <h3 className="text-lg font-semibold text-gray-800">Scan to Chat</h3>
//                 <button
//                   onClick={() => setShowQRModal(false)}
//                   className="text-gray-500 hover:text-gray-700"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>

//               <div className="text-center">
//                 <QRCodeComponent value="https://wa.me/+10000000000" />
//                 <p className="text-sm text-gray-600 mt-4">
//                   Scan this QR code to go directly to chat.
//                 </p>
//               </div>

//               <div className="mt-6 flex justify-end">
//                 <button
//                   onClick={() => setShowQRModal(false)}
//                   className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard;


import React, { useEffect, useState } from 'react';
import { BarChart3, Users, MessageCircle, TrendingUp, Settings, Menu, X, Facebook, Instagram, Phone, Calendar, MapPin, User, Bell, Search, Link, Cookie, Activity, UserCheck } from 'lucide-react';
import ChartComponent from '../../../components/PlatformWiseChart';
import PieChartComponent from '../../../components/PieChartComponent';
import { userProfile } from '../../../store/user/userThunk';
import { getConversationAnalytics } from '../../../store/chart/chartThunk';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ConversationAnalytics from '../../../components/ConversationAnalytics';
import Cookies from "js-cookie";

const Dashboard = () => {
  const { profile } = useSelector((state) => state.userservice);
  const { analyticsData } = useSelector((state) => state.chart);
  const navigate = useNavigate();
  const location = useLocation();
  const [showQRModal, setShowQRModal] = useState(false);
  const dispatch = useDispatch();
  const [isWhatsAppConnected, setIsWhatsAppConnected] = useState(profile?.wpLogin || false);
  useEffect(() => {
    setIsWhatsAppConnected(profile?.wpLogin || false);
  }, [profile?.wpLogin]);

  useEffect(() => {
    // Fetch user profile and analytics data
    dispatch(userProfile());
    dispatch(getConversationAnalytics());

    // Handle URL params for login status
    const urlParams = new URLSearchParams(location.search);
    const loginStatus = urlParams.get('login');
    const provider = urlParams.get('provider');
    const token = urlParams.get('token');

    if (provider === 'google' && token) {
      Cookies.set('token', token, { expires: 45, secure: true, sameSite: 'Strict' });
    }

    if (loginStatus === 'success' && provider) {
      toast.success(`${provider.charAt(0).toUpperCase() + provider.slice(1)} account connected successfully!`);
      navigate(location.pathname, { replace: true });
    }
  }, [dispatch, location, navigate]);

  const QRCodeComponent = ({ value, size = 200 }) => (
    <div className="flex items-center justify-center p-4">
      <div className="w-48 h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
        <span className="text-gray-500 text-sm">QR Code: {value}</span>
      </div>
    </div>
  );

  // Calculate total connected platforms
  const connectedPlatforms = Number(profile?.iglogin || 0) + Number(profile?.Fblogin || 0) + Number(profile?.wpLogin || 0);

  // Get user counts from analytics data or fallback to mock values
  const facebookUserCount = profile?.Fblogin ? (analyticsData?.pieChart?.counts?.facebook) : 0;
  const instagramUserCount = profile?.iglogin ? (analyticsData?.pieChart?.counts?.instagram) : 0;
  const whatsappUserCount = profile?.wpLogin ? (analyticsData?.pieChart?.counts?.whatsapp) : 0;

  return (
    <div className="flex bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
      <div className="flex-1 flex flex-col">
        <main className="flex-1 overflow-x-hidden">
          <div className="container mx-auto px-6 py-8">
            {/* Header Section */}
            <div className="mb-8">
              <div className="flex items-center justify-between mb-6"></div>
            </div>

            {/* Enhanced Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              {/* Total Connected Platforms */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">Connected Platforms</p>
                    <p className="text-3xl font-bold text-gray-900 mb-1">{connectedPlatforms}</p>
                    <div className="flex items-center gap-2">
                      <div className="flex items-center text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">
                        <Activity size={12} className="mr-1" />
                        Active
                      </div>
                      <span className="text-xs text-gray-500">out of 3</span>
                    </div>
                  </div>
                  <div className="p-2 bg-gradient-to-r from-[#4091CC] to-[#50B5FF] rounded-xl">
                    <Link className="text-white" size={24} />
                  </div>
                </div>
              </div>

              {/* Facebook Users */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">Facebook Users</p>
                    <p className="text-3xl font-bold text-gray-900 mb-1">
                      {facebookUserCount?.toLocaleString()}
                    </p>
                    <div className="flex items-center gap-2">
                      <div className={`flex items-center text-xs px-2 py-1 rounded-full ${profile?.Fblogin
                        ? 'text-green-600 bg-green-50'
                        : 'text-red-600 bg-red-50'
                        }`}>
                        <div className={`w-2 h-2 rounded-full mr-1 ${profile?.Fblogin ? 'bg-green-500' : 'bg-red-500'
                          }`}></div>
                        {profile?.Fblogin ? 'Connected' : 'Disconnected'}
                      </div>
                    </div>
                  </div>
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl">
                    <Facebook className="text-white" size={24} />
                  </div>
                </div>
              </div>

              {/* Instagram Users */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">Instagram Users</p>
                    <p className="text-3xl font-bold text-gray-900 mb-1">
                      {instagramUserCount?.toLocaleString()}
                    </p>
                    <div className="flex items-center gap-2">
                      <div className={`flex items-center text-xs px-2 py-1 rounded-full ${profile?.iglogin
                        ? 'text-green-600 bg-green-50'
                        : 'text-red-600 bg-red-50'
                        }`}>
                        <div className={`w-2 h-2 rounded-full mr-1 ${profile?.iglogin ? 'bg-green-500' : 'bg-red-500'
                          }`}></div>
                        {profile?.iglogin ? 'Connected' : 'Disconnected'}
                      </div>
                    </div>
                  </div>
                  <div className="p-2 bg-gradient-to-r from-pink-500 to-purple-600 rounded-xl">
                    <Instagram className="text-white" size={24} />
                  </div>
                </div>
              </div>

              {/* WhatsApp Users */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-1">WhatsApp Users</p>
                    <p className="text-3xl font-bold text-gray-900 mb-1">
                      {whatsappUserCount?.toLocaleString()}
                    </p>
                    <div className="flex items-center gap-2">
                      <div className={`flex items-center text-xs px-2 py-1 rounded-full ${profile?.wpLogin
                        ? 'text-green-600 bg-green-50'
                        : 'text-red-600 bg-red-50'
                        }`}>
                        <div className={`w-2 h-2 rounded-full mr-1 ${profile?.wpLogin ? 'bg-green-500' : 'bg-red-500'
                          }`}></div>
                        {profile?.wpLogin ? 'Connected' : 'Disconnected'}
                      </div>
                    </div>
                  </div>
                  <div className="p-2 bg-gradient-to-r from-green-500 to-green-600 rounded-xl">
                    <Phone className="text-white" size={24} />
                  </div>
                </div>
              </div>
            </div>

            {/* Analytics Component */}
            <ConversationAnalytics
              facebookUserCount={facebookUserCount}
              instagramUserCount={instagramUserCount}
              whatsappUserCount={whatsappUserCount}
            />

            {/* Profile Section with Enhanced Design */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
              {/* Profile Info */}
              <div className="lg:col-span-2 bg-white p-8 rounded-2xl  border border-gray-100">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-semibold text-gray-800">Profile Information</h3>
                  <button className="text-[#4091CC] hover:text-[#367299] text-sm font-medium" onClick={() => navigate('/dashboards/app/profile')}>
                    View Profile
                  </button>
                </div>

                <div className="flex items-start space-x-6">
                  <div className="relative">
                    <img
                      src={profile?.image || 'https://via.placeholder.com/80'}
                      alt="Profile"
                      className="w-20 h-20 rounded-2xl object-cover border-4 border-white"
                    />
                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 border-2 border-white rounded-full"></div>
                  </div>

                  <div className="flex-1">
                    <h4 className="text-xl font-semibold text-gray-900 mb-1">{profile?.fullName || 'User Name'}</h4>
                    <p className="text-[#4091CC] font-medium mb-4">@{profile?.userName || 'username'}</p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                        <User size={18} className="mr-3 text-gray-400" />
                        <div>
                          <span className="text-sm text-gray-600">Gender</span>
                          <p className="font-medium text-gray-900">{profile?.gender || 'Not specified'}</p>
                        </div>
                      </div>

                      <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                        <Calendar size={18} className="mr-3 text-gray-400" />
                        <div>
                          <span className="text-sm text-gray-600">Birth Date</span>
                          <p className="font-medium text-gray-900">{profile?.dob || 'Not specified'}</p>
                        </div>
                      </div>

                      <div className="flex items-center p-3 bg-gray-50 rounded-lg md:col-span-2">
                        <MapPin size={18} className="mr-3 text-gray-400" />
                        <div>
                          <span className="text-sm text-gray-600">Location</span>
                          <p className="font-medium text-gray-900">
                            {profile?.city && profile?.state
                              ? `${profile.city}, ${profile.state}`
                              : 'Not specified'
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-lg font-semibold text-gray-800 mb-6">Quick Actions</h3>
                <div className="space-y-3">
                  <button
                    onClick={() => navigate('/settings')}
                    className="w-full flex items-center justify-between p-3 text-left hover:bg-gray-50 rounded-lg transition-colors duration-200"
                  >
                    <div className="flex items-center">
                      <Settings size={18} className="mr-3 text-[#4091CC]" />
                      <span className="font-medium">Account Settings</span>
                    </div>
                    <div className="text-gray-400">→</div>
                  </button>

                  <button
                    onClick={() => navigate('/dashboards/extrapages/about')}
                    className="w-full flex items-center justify-between p-3 text-left hover:bg-gray-50 rounded-lg transition-colors duration-200"
                  >
                    <div className="flex items-center">
                      <BarChart3 size={18} className="mr-3 text-[#4091CC]" />
                      <span className="font-medium">Instent help</span>
                    </div>
                    <div className="text-gray-400">→</div>
                  </button>

                  <button
                    onClick={() => isWhatsAppConnected && setShowQRModal(true)}
                    className={`w-full flex items-center justify-between p-3 text-left rounded-lg transition-colors duration-200 ${isWhatsAppConnected ? 'hover:bg-gray-50' : 'opacity-50 cursor-not-allowed'
                      }`}
                    disabled={!isWhatsAppConnected}
                  >
                    <div className="flex items-center">
                      <Phone size={18} className="mr-3 text-[#4091CC]" />
                      <span className="font-medium">WhatsApp QR</span>
                    </div>
                    <div className="text-gray-400">→</div>
                  </button>

                  <div className="mt-6 p-4 bg-gradient-to-r from-[#4091CC]/10 to-[#50B5FF]/10 rounded-lg border border-[#4091CC]/20">
                    <h4 className="font-medium text-gray-800 mb-2">Need Help?</h4>
                    <p className="text-sm text-gray-600 mb-3">Get support or learn more about our features.</p>
                    <button className="text-[#4091CC] text-sm font-medium hover:underline" onClick={() => navigate('/pages/contact-us')}>
                      Contact Support →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Enhanced QR Code Modal */}
      {showQRModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">WhatsApp QR Code</h3>
                  <p className="text-gray-600 text-sm">Scan to start chatting</p>
                </div>
                <button
                  onClick={() => setShowQRModal(false)}
                  className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                >
                  <X size={20} />
                </button>
              </div>

              <div className="text-center">
                <QRCodeComponent value={`https://wa.me/${profile?.phoneNumber || '+10000000000'}`} />
                <div className="mt-4 p-4 bg-green-50 rounded-lg">
                  <p className="text-sm text-green-800 font-medium mb-1">
                    Ready to Connect
                  </p>
                  <p className="text-xs text-green-600">
                    Scan this QR code with your phone to start a WhatsApp conversation.
                  </p>
                </div>
              </div>

              <div className="mt-6 flex gap-3">
                <button
                  onClick={() => setShowQRModal(false)}
                  className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200 font-medium"
                >
                  Close
                </button>
                <button
                  onClick={() => window.open(`https://wa.me/${profile?.phoneNumber}`, '_blank')}
                  className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 font-medium"
                >
                  Open WhatsApp
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;